const theme = {
  primaryColor: "#E7343F",
  secondaryColor: "#F8F8F8",
  logo: "/assets/swissnex-logo.png",
  fontFamily: "Helvetica Neue, Arial, sans-serif",
  floatingButtonText: "Chat",
  borderRadius: 10,
}

export default theme